export default function usePanel() {
  const { $api } = useNuxtApp()

  const user = useState<IUser | null>('panel-user', () => null)

  async function fetchUser(): Promise<IUser> {
    return new Promise((resolve, reject) => 
      $api<IUser>('/edu/auth/profile')
      .then((res: IUser) => {
        user.value = res

        resolve(res)
      })
      .catch((e: any) => reject(e))
    )
  }

  const setUserSetting = (data: Object) => {
    if (user.value === null) return

    user.value.settings = {
      ...user.value?.settings ?? {},
      ...data
    }
  }

  return { user, fetchUser, setUserSetting }
}